import React from "react";
import _ from "lodash";
import { Card, Col, Row, Input, Button, Form } from "antd";
import { withRouter, Redirect } from "react-router-dom";
// import { authenticate } from "utils/authService";
import { BuildingIcon, UserIcon, EmailIcon, AtIcon } from "components/Icons";
import axios from "axios";
import AppLoader from "components/AppLoader";
import message from 'components/CustomMessage';

const Register = withRouter(
    class Register extends React.Component{
        state = {
            userData: {}
        }
        constructor(props){
            super(props);

            _.bindAll(
                this,
                "onFinish"
            );
        }
        async onFinish({companyName}){
            const {history} = this.props;
            const {userData} = this.state;
            const {email, firstName, lastName, domain, token} = userData;
            // const redirectTo = search ? search.substr(1) : "/";
            try{
                await axios.post("/api/signup/", {
                    companyName, 
                    email,
                    firstName,
                    lastName,
                    domain,
                    tokenId: token
                });
                history.replace("/registrationSuccess");
            } catch (e){
                message.error(_.result(e, "response.data", _.result(e, "message")));
                console.error(e);
            }
            // console.log('Received values of form: ', values);
        }
        async componentDidMount(){
            const {search} = this.props.location;
            const params = new URLSearchParams(search);
            const token = params.get("token");
            try{
                const response = await axios.get(`/api/token/validate?tokenId=${token}`);
                console.log(response.data);
                if(response.data){
                    this.setState({
                        userData: {
                            email: params.get("email"),
                            firstName: params.get("firstName"),
                            lastName: params.get("lastName"),
                            domain: params.get("domain"),
                            token
                        }
                    });
                } else {
                    this.setState({
                        userData: {
                            email: null
                        }
                    });
                }
            } catch (e){
                console.error(e);
            }
        }
        render(){
            const {userData} = this.state;
            const {email, firstName, lastName, domain} = userData;
            const colProps = {
                lg: 8,
                md: 10,
                sm: 14,
                xs: 24,
                style: {margin: "auto", marginTop: "10vh"}
            }
            if(_.isEmpty(userData)){
                return <AppLoader />;
            }
            if(!email || !firstName || !lastName || !domain){
                return <Redirect to="/403" />;
            }
            return (
                <div className="login-page">
                    <Row>
                        <Col {...colProps}>
                            <Card 
                                bordered={false}
                                className="login-box" 
                                title={<div className="text-center" style={{fontSize: "1.5em"}}>Sign up</div>}
                            >
                                <Form
                                    name="normal_login"
                                    className="login-form"
                                    layout="vertical"
                                    initialValues={{ 
                                        remember: true ,
                                        name: `${firstName} ${lastName}`,
                                        email,
                                        domain
                                    }}
                                    onFinish={this.onFinish}
                                >
                                    <Form.Item
                                        name="name"
                                        label="Name"
                                    >
                                        <Input prefix={<UserIcon />} disabled />
                                    </Form.Item>

                                    <Form.Item
                                        name="email"
                                        label="Email"
                                    >
                                        <Input prefix={<EmailIcon />} disabled />
                                    </Form.Item>

                                    <Form.Item
                                        name="domain"
                                        label="Company Domain"
                                    >
                                        <Input prefix={<AtIcon />} disabled />
                                    </Form.Item>

                                    <Form.Item
                                        name="companyName"
                                        label="Company Name"
                                        rules={[{ required: true, message: 'Please input your Company Name!' }]}
                                    >
                                        <Input prefix={<BuildingIcon />} />
                                    </Form.Item>

                                    <Form.Item noStyle>
                                        <Button type="primary" htmlType="submit" className="login-form-button" block>
                                            Submit
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </Card>
                        </Col>
                    </Row>
                </div>
            )
        }
    }
)

export default Register;